import { GOOGLE_RATING, IS_ISO_CERTIFICATION_CONFIRMED } from '../../../core/constants/landing';
import { BRAND } from '../../../core/constants/site';
import { IconStar } from '../../../common/icons';

import '../styles/trust-strip.css';

export default function TrustStrip() {
    return (
        <aside className="trust-strip" aria-label="Datos de confianza">
            <ul className="trust-strip__list container">
                <li className="trust-strip__item">
                    Desde <strong className="trust-strip__strong">{BRAND.foundingYear}</strong>
                </li>
                <li className="trust-strip__item">
                    <strong className="trust-strip__strong">{GOOGLE_RATING.score}</strong>
                    <span className="trust-strip__star"><IconStar size={14} /></span>
                    en Google ({GOOGLE_RATING.reviewCount} reseñas)
                </li>
                {IS_ISO_CERTIFICATION_CONFIRMED && (
                    <li className="trust-strip__item">
                        <strong className="trust-strip__strong">ISO 9001:2015</strong>
                    </li>
                )}
                <li className="trust-strip__item">{BRAND.city}</li>
            </ul>
        </aside>
    );
}
